import { render, staticRenderFns } from "./AccountOrderPreview.vue?vue&type=template&id=1d72aa03"
import script from "./AccountOrderPreview.vue?vue&type=script&lang=js"
export * from "./AccountOrderPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLazy } from 'vuetify/lib/components/VLazy';
import { VResponsive } from 'vuetify/lib/components/VResponsive';
installComponents(component, {VCard,VImg,VLazy,VResponsive})
